module.exports = __webpack_public_path__ + "img/94852.fa5503e1.svg";